import React from 'react';
import { useTranslation } from 'utils/i18n';
import homepageTranslations from '../../translations';
import { Icons } from 'components/Icons';
import './TrustBadges.css';

const TrustBadges = () => {
  const { language } = useTranslation();
  
  const t = (key, defaultValue = '') => {
    const pageTranslations = homepageTranslations[language] || homepageTranslations.en;
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations.customerHomepage?.trustBadges || {});
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
    return defaultValue !== '' ? defaultValue : key;
  };

  const badges = [
    {
      id: 'gdpr',
      icon: <Icons.Shield size={20} />,
      label: t('gdpr', 'GDPR Compliant')
    },
    {
      id: 'european',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
      ),
      label: t('european', 'European Hosted')
    },
    {
      id: 'enterprise',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      ),
      label: t('enterprise', 'Enterprise Ready')
    }
  ];

  return (
    <section className="trust-badges">
      <div className="trust-badges-container">
        <div className="trust-badges-content">
          {badges.map((badge, index) => (
            <React.Fragment key={badge.id}>
              <div className="trust-badge">
                <div className="trust-badge-icon">
                  {badge.icon}
                </div>
                <span className="trust-badge-label">{badge.label}</span>
              </div>
              {index < badges.length - 1 && (
                <div className="trust-badge-divider" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;

